import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { FootballIcon, FriendListBg } from "@assets";

const Box = styled.div`
  padding: 16px;
  @media screen and (max-width: 320px) {
    padding: 16px 8px;
  }
  background: #fff;
  border-radius: 16px 16px 0px 0px;
  min-height: 400px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

export const Title = styled.div`
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  padding-left: 3px;
  padding-right: 3px;
  line-height: 35px;
`;

const Text = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  color: #808080;
  padding: 16px;
  background: #e1f0ff;
  border-radius: 10px;
  margin-top: 8px;
  text-align: left;
`;

export const TitleWrapper = styled.div`
  background-image: url(${FriendListBg});
  background-repeat: no-repeat;
  background-position: center; /* Center the background image horizontally and vertically */
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
`;

const TermsConditions = ({ title, rule }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <TitleWrapper>
        <FootballIcon />
        <Title>{`${title} ${t("common.termsAndConditions")}`}</Title>
        <FootballIcon />
      </TitleWrapper>
      <Text dangerouslySetInnerHTML={{ __html: rule }} />
    </Box>
  );
};

export default TermsConditions;
